






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {ResponseRoboCnpj} from '@/model/resource/ResponseRoboCnpj'
import {InputResponseRoboCnpjSchema} from '@/schema/resource/ResponseRoboCnpj/InputResponseRoboCnpjSchema'

@Component
export default class PersistResponseRoboCnpjView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputResponseRoboCnpjSchema()
  responseRoboCnpj = new ResponseRoboCnpj()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.responseRoboCnpj.getResponseRoboCnpj(id)
    }

    $.await.done('getResponseRoboCnpj')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.responseRoboCnpj.persistResponseRoboCnpj()
    await Helper.successAndPush(
      'system.success.persist',
      '/response-robo-cnpj/list'
    )
  }
}
